import {
  BIZ_CHANNEL_TALK_CHANNEL_SEARCHABLE,
  BIZ_CHANNEL_TALK_CHANNEL_STATUS,
  CampaignTypes,
} from '../../../Codes'
import PropTypes from 'prop-types'

const BizChannelAfter = ({ after, type, subType }) => (
  <>
    {after.websiteUrl && (
      <tr>
        <th scope="row">웹사이트 URL</th>
        <td>
          <div className="inner_cell">{after.websiteUrl}</div>
        </td>
      </tr>
    )}
    {after.accessAccountYn && (
      <tr>
        <th scope="row">검수계정</th>
        <td>
          <div className="inner_cell">{after.accessAccountYn}</div>
        </td>
      </tr>
    )}
    {after.talkChannel && (
      <tr>
        <th scope="row">카카오톡 채널</th>
        <td>
          <div className="inner_cell">{after.talkChannel}</div>
        </td>
      </tr>
    )}
    {after.category && (
      <tr>
        <th scope="row">업종</th>
        <td>
          <div className="inner_cell">{after.category}</div>
        </td>
      </tr>
    )}
    {(type === 'TALK_CHANNEL_BIZCHANNEL_ENABLE' ||
      type === 'TALK_CHANNEL_BIZCHANNEL_DISABLE') &&
      after.name && (
        <tr>
          <th scope="row">카카오톡 채널</th>
          <td>
            <div className="inner_cell">{after.name}</div>
          </td>
        </tr>
      )}
    {subType === CampaignTypes.TALK_CHANNEL && after.permalink && (
      <tr>
        <th scope="row">채널 홈 URL</th>
        <td>
          <div className="inner_cell">{after.permalink}</div>
        </td>
      </tr>
    )}
    {subType === CampaignTypes.TALK_CHANNEL && after.status && (
      <tr>
        <th scope="row">채널 홈 공개 상태</th>
        <td>
          <div className="inner_cell">
            {BIZ_CHANNEL_TALK_CHANNEL_STATUS[after.status]}
          </div>
        </td>
      </tr>
    )}
    {subType === CampaignTypes.TALK_CHANNEL && after.searchable && (
      <tr>
        <th scope="row">채널 검색 허용 상태</th>
        <td>
          <div className="inner_cell">
            {BIZ_CHANNEL_TALK_CHANNEL_SEARCHABLE[after.searchable]}
          </div>
        </td>
      </tr>
    )}
    {subType === CampaignTypes.TALK_CHANNEL &&
      after.dormantAt !== undefined && (
        <tr>
          <th scope="row">채널 휴면 상태</th>
          <td>
            <div className="inner_cell">
              {after.dormantAt ? '채널 상태: 휴면' : '채널 상태: 휴면 아님'}
            </div>
          </td>
        </tr>
      )}
    {subType === CampaignTypes.TALK_CHANNEL && after.adult && (
      <tr>
        <th scope="row">성인 채널 여부</th>
        <td>
          <div className="inner_cell">
            {after.adult === 'Y' ? '성인 채널' : '성인 채널 아님'}
          </div>
        </td>
      </tr>
    )}
    {subType === CampaignTypes.TALK_CHANNEL && after.usable && (
      <tr>
        <th scope="row">채널명</th>
        <td>
          <div className="inner_cell">
            {after.usable === 'Y' ? '사용 가능' : '사용 불가'}
          </div>
        </td>
      </tr>
    )}
    {(type === 'TALK_CHANNEL_BIZCHANNEL_ENABLE' ||
      type === 'TALK_CHANNEL_BIZCHANNEL_DISABLE') &&
      after.spamLevel !== undefined && (
        <tr>
          <th scope="row">채널 제재 단계</th>
          <td>
            <div className="inner_cell">
              {after.spamLevel === 0 || after.spamLevel === 1
                ? '광고 집행 가능'
                : '광고 집행 불가능'}
            </div>
          </td>
        </tr>
      )}
  </>
)
export default BizChannelAfter

BizChannelAfter.propTypes = {
  after: PropTypes.shape({
    websiteUrl: PropTypes.string,
    accessAccountYn: PropTypes.string,
    talkChannel: PropTypes.string,
    category: PropTypes.string,
    permalink: PropTypes.string,
    status: PropTypes.string,
    searchable: PropTypes.string,
    dormantAt: PropTypes.string,
    adult: PropTypes.string,
    usable: PropTypes.string,
    spamLevel: PropTypes.number,
    name: PropTypes.string,
  }),
  type: PropTypes.string,
  subType: PropTypes.string,
}
